import React from 'react';
import styled from 'styled-components';

export const Category = ({id, name }) => {
    const handleClick = () => {
        window.location.href = `/menu/${id}`;
    }
  return (
    <Container onClick={handleClick} data-aos="flip-up" data-aos-offset="50" data-aos-duration="750">
        <div className='name'>
            <h3>{name}</h3>
        </div>
    </Container>
  )
}

const Container = styled.div`
    cursor: pointer;
    margin: 2.25rem auto 0 auto;
    max-width: 450px;
    width: 90%;
    padding: 1rem 1.5rem;
    background-color: rgba(0,0,0,.6);
    box-shadow: 0 0 10px 1px rgba(205, 15, 26, .25);
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover{
        box-shadow: 0 0 10px 3px rgba(205, 15, 26,.5);
    }

    h3{
        color: #fff;
        font-size: 1.1rem;
        text-align: center;
    }
`;

